import { useEffect, useState, useContext } from 'react'
import { AxiosResponse } from 'axios'
import pclnRequest from '@pcln/request'
import analytics from '@/shared-utils/analytics'
import config from 'isomorphic-config'
import { SMS_DISCLAIMER_TEXT_QUERY } from '@/shared-utils/queries/smsOptIn'
import { GraphQLResponse } from '@/types'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import SMS_DISCLAIMER_TEXT_INITIAL_VALUE from '@/constants/sms-disclaimer-text'

export type Disclaimers = {
  optinStatus: unknown
  disclaimerText: {
    text: string
    url: string | null
  }[]
}

export type DisclaimerBaseParams = {
  disclaimerBaseParam: {
    placement: string
    appCode: string
    classification: string
    PLFCode: string
  }
}

export type DisclaimersResponse = {
  smsDisclaimerText: {
    disclaimers: [Disclaimers]
  }
}

const useGetDisclaimer = (baseParams: DisclaimerBaseParams) => {
  const [disclaimers, setDisclaimers] = useState<Disclaimers[]>(
    SMS_DISCLAIMER_TEXT_INITIAL_VALUE
  )
  const {
    webstats: { clientGUID }
  } = useContext(BootstrapDataContext)

  useEffect(() => {
    async function fetchSmsDisclaimer() {
      try {
        const { url, timeout } = config.client['pcln-graph']
        const response: AxiosResponse<GraphQLResponse<DisclaimersResponse>> =
          await pclnRequest({
            url,
            timeout,
            method: 'POST',
            data: {
              query: SMS_DISCLAIMER_TEXT_QUERY,
              variables: baseParams
            }
          })
        const { errors, data } = response.data
        if (Array.isArray(errors) && errors.length > 0) {
          const errorMessage =
            errors instanceof Error
              ? errors.message
              : ((errors as any).toString() as string)
          analytics.logError({
            message: `Failed to enroll for SMS subscription for cGuid: ${clientGUID} Error message: ${errorMessage}`
          })
          return
        }
        if (data) {
          // TODO remove success log in seti cleanup. seti: HP_SMS_COMPONENT
          analytics.log({
            message: `Fetched disclaimer for cGuid: ${clientGUID}`
          })
          setDisclaimers(data.smsDisclaimerText?.disclaimers)
        }
      } catch (error) {
        const errorMessage =
          error instanceof Error
            ? error.message
            : ((error as any).toString() as string)
        analytics.logError({
          message: `Failed to query for SMS disclaimer text for cGuid: ${clientGUID}. Error message: ${errorMessage}`
        })
      }
    }
    fetchSmsDisclaimer()
  }, [baseParams, clientGUID])

  return disclaimers
}

export default useGetDisclaimer
